var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{class:{'balsa-recently-row':_vm.hoverVisible}},[_vm._t("divider"),_c('el-row',{attrs:{"type":"flex","align":"middle"}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }